module.exports = __webpack_public_path__ + "static/Verne6-d5bef136301e27410350d0151f6b0000.png";